import { FC } from 'react'

import { DatePicker, FF, FormType, RadioGroup, TextInput } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const SignedCompletion: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col>
          <h5>Signed Completion</h5>
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="signedCompletionName"
            children={(field) => <FF field={field} label="Name" input={(p) => <TextInput {...p} />} />}
          />
        </Col>
        <Col>
          <formApi.Field
            name="signedCompletionDate"
            children={(field) => <FF field={field} label="Date" input={(p) => <DatePicker {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            If this is the 3rd Quarterly HRR-Email the list of required documents for the annual review to the customer
            giving them a deadline of 30 days prior to when you need to have the Annual HRR and SAR completed
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="annualReviewDocumentRequestSend"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>MRB QC SAR Checklist was completed and saved in the file</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="checklistCompletedAndSaved"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
    </>
  )
}
